import { render, staticRenderFns } from "./CartVariantCard.vue?vue&type=template&id=4d4e8cc0&lang=pug"
import script from "./CartVariantCard.vue?vue&type=script&lang=js"
export * from "./CartVariantCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports